import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

export const LineupsGrid = styled(Horizontal)`
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  & > * {
    max-width: 100%;
  }

  @media ${tabletAndAbove} {
    & > * {
      max-width: calc(50% - var(--unit));
    }
  }
`;
